import axios from 'axios';
import { setToStorage as setToLocalStorage, getFromStorage as getFromLocalStorage, deleteFromStorage as deleteFromLocalStorage } from '@/helpers/localStorage';
import { getClaimsFromToken, isTokenExpired } from './jwt-token';


async function tryExchangeToken(store: any): Promise<void> {
  const refreshToken = getFromLocalStorage('refreshToken');
  if (!refreshToken) {
    store.dispatch('LOGOUT');
    return;
  }
  try {
    const baseURL = window.location.origin;
    // const baseURL = 'https://blkexp.geeq-test.io';
    const res = await axios.post(`${baseURL}/api/admin/auth/exchange`, { token: refreshToken });
    const result = res.data?.result;
    if (result?.access) {
      setToLocalStorage('token', result.access);
      if (result.refresh) {
        setToLocalStorage('refreshToken', result.refresh);
      }
      store.dispatch('LOGIN');
    } else {
      store.dispatch('LOGOUT');
    }
  } catch {
    store.dispatch('LOGOUT');
  }
}

export function init(store: any, router: any) {
  const token = getFromLocalStorage('token');
  if (token) {
    const claims = getClaimsFromToken(token) as { exp: number } | null;
    if (claims) {
      const { exp } = claims;
      const isExpired = isTokenExpired(exp);
      if (isExpired) {
        console.log('Token Expired — attempting token exchange');
        deleteFromLocalStorage('token');
        store.commit('SET_IS_LOGGED_IN', false);
        tryExchangeToken(store);
      }
    }
  }

  // Define Middleware for router
  router.beforeEach((to: any, from: any, next: any) => {
    const { access } = to.query;
    const storedToken = getFromLocalStorage('token');
    if (access) {
      setToLocalStorage('token', access);
      store.dispatch('LOGIN');
    } else if (storedToken) {
      store.dispatch('LOGIN');
    }
    next();
  });
}
